import {Particles} from "../../Core/Particles";
import {texture} from "../../Core/AssetHelpers";

export class MusicNotesEmit extends Particles {

    constructor(width: number, height: number, color = "#ffffff") {
        super([1, 2].map(i => texture(`music-note-${i}`)!), {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 2,
                "end": 3,
                "minimumScaleMultiplier": 0.5
            },
            "color": {
                "start": color,
                "end": color
            },
            "speed": {
                "start": 500,
                "end": 300,
                "minimumSpeedMultiplier": 0.5
            },
            "acceleration": {
                "x": 0,
                "y": 0
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": -100,
                "max": -80
            },
            "noRotation": true,
            "rotationSpeed": {
                "min": -100,
                "max": 100
            },
            "lifetime": {
                "min": 0.4,
                "max": 1.2
            },
            "blendMode": "normal",
            "frequency": 0.1,
            "emitterLifetime": 0,
            "maxParticles": 100,
            "pos": {
                "x": 0,
                "y": 0
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -width * 0.5,
                "y": -height * 0.6,
                "w": width,
                "h": height
            }
        });
        this.emitter.autoUpdate = true;
        this.emitter.emit = false;
    }
}